import React, { useState, useReducer } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { withStyles } from '@material-ui/core';

import Dashboard from '../../../../layouts/Dashboard';

import CustomBackdrop from '../../../../components/CustomBackdrop';
import { organisationReducer } from '../Common';
import Steps from '../Common/components/Steps';

import { createOrganisation } from './mutations';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const CreateOrganisation = ({ classes, history }: Props): React.ReactElement => {
  const [organisation, dispatchOrganisation] = useReducer(organisationReducer, {
    name: '',
    email: '',
    phone: '',
    organisation_type: '',
    currency: '',
    locale: '',
    tax_rate: 0,
  });

  const [saving, setSaving] = useState<boolean>(false);

  const handleSave = async () => {
    setSaving(true);

    const insertOrganisationVariables = {
      object: organisation,
    };
    const organisation_id: string | undefined = await createOrganisation(insertOrganisationVariables);
    if (organisation_id) {
      setSaving(false);
      handleFinish(organisation_id);
    }
  };

  const handleFinish = (id: string) => {
    history.push(`/admin/organisations/${id}`);
  };

  return (
    <>
      <Dashboard breadcrumbs={[{ label: 'Organisations', link: '/admin/organisations' }, { label: 'Create' }]}>
        <Steps completeLabel="Create" organisation={organisation} dispatch={dispatchOrganisation} handleSave={handleSave} />
      </Dashboard>
      {saving && <CustomBackdrop label="Creating Organisation" />}
    </>
  );
};

export default withRouter(withStyles(styles)(CreateOrganisation));
